module.exports = __webpack_public_path__ + "static/media/python.8eacb570.png";